(function () {
    function init() {
    var stage = document.querySelector('.hero-globe-stage');
    var glow = document.querySelector('.hero-globe-glow');
    if (!stage || !glow) return;
    var mv = stage.querySelector('model-viewer');
    if (!mv) return;

    var sources = (mv.getAttribute('data-globe-sources') || '').split('|');
    var cleaned = [];
    for (var s = 0; s < sources.length; s++) {
    var u = sources[s].trim();
    if (u && u.indexOf('/') !== -1 && cleaned.indexOf(u) === -1) cleaned.push(u);
    }

    var idx = 0;
    function tryNext() {
    if (idx >= cleaned.length) {
    console.warn('[hero-globe] no model file matched. Tried:', cleaned);
    return;
    }
    mv.src = cleaned[idx];
    idx = idx + 1;
    }
    mv.addEventListener('error', tryNext);
    tryNext();

    var buf = document.createElement('canvas');
    buf.width = 12;
    buf.height = 12;
    var ctx = buf.getContext('2d', { willReadFrequently: true });

    var busy = false;
    var last = 0;
    var visible = true;

    if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
    visible = entries[0].isIntersecting;
    }).observe(stage);
    }

    function sample() {
    var now = performance.now();
    if (busy || !visible || now - last < 150) return;
    busy = true;
    last = now;
    try {
    var img = new Image();
    img.onload = function () {
    try {
    ctx.clearRect(0, 0, 12, 12);
    ctx.drawImage(img, 0, 0, 12, 12);
    var d = ctx.getImageData(0, 0, 12, 12).data;
    var r = 0, g = 0, b = 0, n = 0;
    for (var i = 0; i < d.length; i += 4) {
if (d[i + 3] < 16) continue;
    if (d[i] + d[i + 1] + d[i + 2] < 24) continue;
    r += d[i]; g += d[i + 1]; b += d[i + 2]; n++;
    }
    if (n) {
    var k = 0.34;
    glow.style.setProperty('--globe-tint', 'rgb(' + Math.round((r / n) * k) + ',' + Math.round((g / n) * k) + ',' + Math.round((b / n) * k) + ')');
    }
    } catch (e) {}
    busy = false;
    };
    img.onerror = function () { busy = false; };
    img.src = mv.toDataURL('image/jpeg', 0.5);
    } catch (e) {
    busy = false;
    }
    }

    mv.addEventListener('camera-change', sample);
mv.addEventListener('load', sample);
setInterval(sample, 400);
if (mv.loaded) sample();

function applyEight() {
fetch(mv.src).then(function (res) { return res.arrayBuffer(); }).then(function (buf) {
var dv = new DataView(buf);
var jsonLen = dv.getUint32(12, true);
var gltf = JSON.parse(new TextDecoder().decode(new Uint8Array(buf, 20, jsonLen)));
var binOffset = 20 + jsonLen + 8;
var im = gltf.images[0];
var bv = gltf.bufferViews[im.bufferView];
var png = new Uint8Array(buf, binOffset + (bv.byteOffset || 0), bv.byteLength);
return createImageBitmap(new Blob([png], { type: 'image/png' }));
}).then(function (bmp) {
var c = document.createElement('canvas');
c.width = bmp.width;
c.height = bmp.height;
var x = c.getContext('2d');
x.drawImage(bmp, 0, 0);
var cx = 512, cy = 440;
var e = document.createElement('canvas');
e.width = 1024;
e.height = 1024;
var ex = e.getContext('2d');
var grad = ex.createLinearGradient(0, 230, 0, 700);
grad.addColorStop(0, '#aab1b8');
grad.addColorStop(0.35, '#6a727b');
grad.addColorStop(0.5, '#3f474f');
grad.addColorStop(1, '#565e66');
ex.fillStyle = grad;
ex.beginPath();
ex.arc(cx, cy - 90, 115, 0, 6.2832);
ex.fill();
ex.beginPath();
ex.arc(cx, cy + 110, 140, 0, 6.2832);
ex.fill();
ex.globalCompositeOperation = 'destination-out';
ex.beginPath();
ex.arc(cx, cy - 90, 48, 0, 6.2832);
ex.fill();
ex.beginPath();
ex.arc(cx, cy + 110, 62, 0, 6.2832);
ex.fill();
x.drawImage(e, 0, 0);
return mv.createTexture(c.toDataURL('image/png'));
}).then(function (tex) {
var mats = mv.model.materials;
for (var m = 0; m < mats.length; m++) {
if (mats[m].name === 'emblem_patch') {
mats[m].pbrMetallicRoughness.baseColorTexture.setTexture(tex);
}
}
}).catch(function (e) {
console.warn('[hero-globe] 8 texture skipped:', e);
});
}
mv.addEventListener('load', applyEight);
document.fonts.load('700 100px Fredoka').then(function () { if (mv.loaded) applyEight(); });
    }

    if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
    } else {
    init();
    }
    })();